import workspaceQuery from '../../../graphql/queries/product/StockCommitment.graphql';
import fragment from '../../../graphql/fragments/product/StockCommitmentFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';

const StockCommitment: EntityType = {
  type: 'StockCommitment',
  title: 'Stock Commitment',
  workspaceUrl: '/Products/StockCommitments/Workspace',
  workspace: workspaceQuery,
  fragment,
  screenReference: 'STOCK_COMMITMENT',
  operations: ALLOW_VIEW,
};

export default StockCommitment;
